import api from './api';

export const getMyDashboard = () => api.get('/affiliate/me').then(r => r.data);
